import { apiV1 } from './api';

const fetchMemberClasses = (organisationId) =>
  apiV1.get(`/organisations/${organisationId}/member_classes`);

export { fetchMemberClasses };
